<template>
  <div>
    <!-- add strain popup -->
    <vs-popup id="add_strain__modal" class="vs-con-loading__container" title="Add Strain" button-accept="false" button-cancel="false" :active.sync="isActive">
      <form method="POST" @submit.prevent="save_changes">
        <div class="vx-row pt-5 px-5">
          <div class="vx-col w-full px-8">
            <!-- strain name -->
            <div class="vx-row mb-2">
              <vs-input icon="icon icon-package" v-model="form.name" icon-pack="feather" class="w-full" label="Strain Name" name="Strain Name" v-validate="'required'" />
              <span class="text-danger text-sm" v-show="errors.has('Strain Name')">{{ errors.first('Strain Name') }}</span>
            </div>

            <!-- testing status -->
            <div class="vx-row mb-2">
              <label for="">Testing Status</label>
              <select-2
                class="w-full"
                :value="form.testing_status"
                @input="item => (form.testing_status = item && item.value)"
                name="Testing Status"
                placeholder="Select Testing Status"
                autocomplete
                :options="testingStatusOption"
                disabled
              />
            </div>

            <!-- thc leval -->
            <div class="vx-row mb-2">
              <vs-input
                type="number"
                step="0.0001"
                v-model="form.thc_level"
                @change="form.thc_level = mathRound(form.thc_level || 0, 4)"
                icon="icon icon-list"
                icon-pack="feather"
                class="w-full"
                label="THC Level"
                name="THC"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('THC')">{{ errors.first('THC') }}</span>
            </div>

            <!-- cbd leval -->
            <div class="vx-row mb-2">
              <vs-input
                type="number"
                step="0.0001"
                v-model="form.cbd_level"
                @change="form.cbd_level = mathRound(form.cbd_level || 0, 4)"
                icon="icon icon-list"
                icon-pack="feather"
                class="w-full"
                label="CBD Level"
                name="CBD"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('CBD')">{{ errors.first('CBD') }}</span>
            </div>

            <!-- indica percentage -->
            <div class="vx-row mb-2">
              <vs-input
                type="number"
                step="0.01"
                v-model="form.indica_percentage"
                @change="form.indica_percentage = mathRound(form.indica_percentage || 0, 2)"
                icon="icon icon-list"
                icon-pack="feather"
                class="w-full"
                label="Indica Percentage"
                name="Indica Percentage"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('Indica Percentage')">{{ errors.first('Indica Percentage') }}</span>
            </div>

            <!-- sativa percentage -->
            <div class="vx-row mb-2">
              <vs-input
                type="number"
                step="0.01"
                v-model="form.sativa_percentage"
                @change="form.sativa_percentage = mathRound(form.sativa_percentage || 0, 2)"
                icon="icon icon-list"
                icon-pack="feather"
                class="w-full"
                label="Sativa Percentage"
                name="Sativa Percentage"
                v-validate="'required'"
              />
              <span class="text-danger text-sm" v-show="errors.has('Sativa Percentage')">{{ errors.first('Sativa Percentage') }}</span>
            </div>
          </div>
        </div>

        <!-- Save & Reset Button -->
        <div class="vx-row pt-5 px-5 text-center">
          <div class="vx-col w-full px-8">
            <div class="mt-4 items-center">
              <vs-button button="submit" type="relief" :disabled="!validateForm || loading">Add Strain</vs-button>
              <vs-button color="danger" type="relief" class="ml-2 text-left" @click="closeStrainModal">Cancel</vs-button>
            </div>
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>

<script>
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { paymentMixins } from '@/utils/paymentTypes'

export default {
  name: 'CreateBatch',

  components: {
    Select2
  },

  props: {
    showModal: Boolean
  },

  data: () => ({
    loading: false,
    form: {
      name: '',
      testing_status: 'None',
      thc_level: 0,
      cbd_level: 0,
      indica_percentage: 0,
      sativa_percentage: 0
    },
    testingStatusOption: [{ label: 'None', value: 'None' }]
  }),

  mixins: [paymentMixins],

  computed: {
    validateForm() {
      return !this.errors.any()
    },

    // close the poup
    isActive: {
      get() {
        return this.showModal
      },
      set(val) {
        this.$emit('update:showModal', val)
      }
    }
  },

  methods: {
    async save_changes() {
      if (!(await this.$validator.validate())) {
        return false
      }

      this.loading = true
      this.$store
        .dispatch('strain/insert', this.form)
        .then(res => {
          this.$vs.notify({
            title: 'Success',
            text: res.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.resetForm()
          this.$emit('updateList', res.data)

          this.isActive = false
        })
        .catch(err => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },

    // reset form data
    resetForm() {
      this.form = {
        name: '',
        testing_status: 'None',
        thc_level: 0,
        cbd_level: 0,
        indica_percentage: 0,
        sativa_percentage: 0
      }

      this.$nextTick(() => {
        this.errors.clear()
        this.$validator.reset()
      })
    },

    // close strain modal
    closeStrainModal() {
      this.isActive = false
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#add_strain__modal',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#add_strain__modal > .con-vs-loading')
      }
    }
  }
}
</script>

<style lang="scss">
#add_strain__modal {
  .vs-popup {
    width: calc(100% - 80%) !important;
  }
}
</style>
